<ng-container *ngIf="!imgLoaded">
  <p class="placeholder-glow">
    <span class="placeholder col-12 w-100"></span>
  </p>
</ng-container>
<div class="main-content" *ngIf="imgLoaded">
  <div class="inbt-homepage">
    <div class="product-banner" id="caraousel-scroll">
      <ng-container
        *ngIf="homePageData?.mainBannerResponse && homePageData?.mainBannerResponse?.length == 0; else loadingWebBannerListContent">
        <p class="placeholder-glow">
          <span class="placeholder col-12 w-100"></span>
        </p>
      </ng-container>
      <ng-template #loadingWebBannerListContent>
        <div #carousel *ngIf="homePageData?.mainBannerResponse" class="position-relative">
          <owl-carousel-o [options]="utils.customOptionsForBanner" (changed)="handleSlideChange($event, 'web')" #owlCar>
            <ng-container *ngFor="let slideData of homePageData?.mainBannerResponse;let i=index">
              <ng-template carouselSlide>
                <a [href]="slideData.ctaLink" (click)="triggerBannerClick(slideData)">
                  <picture>
                    <!-- Mobile image -->
                    <source [srcset]="getOptimizedImageUrl(slideData.mobileImageFile, {
                        width: 768,
                        height: 900,
                        quality: 80,
                        format: 'webp'
                      })" media="(max-width: 768px)" [sizes]="'100vw'" width="768" height="900">

                    <!-- Desktop image -->
                    <source [srcset]="getOptimizedImageUrl(slideData.webImageFile, {
                        width: 1688,
                        height: 520,
                        quality: 80,
                        format: 'webp'
                      })" media="(min-width: 769px)" [sizes]="'100vw'" width="1688" height="520">

                    <!-- Fallback image -->
                    <img [src]="getOptimizedImageUrl(slideData.webImageFile, { width: 1688, height: 520 })"
                      [alt]="slideData.altTag" [loading]="i == 0 ? 'eager' : 'lazy'" width="1688" height="520"
                      class="w-100 h-auto" [attr.fetchpriority]="i == 0 ? 'high' : 'auto'"
                      [attr.rel]="i == 0 ? 'preload' : null">

                  </picture>
                </a>
              </ng-template>
            </ng-container>
          </owl-carousel-o>

          <!-- Navigation Buttons -->
          <button class="owl-nav d-flex justify-content-center align-items-center owl-prev"
            *ngIf="homePageData?.mainBannerResponse && homePageData.mainBannerResponse.length >= 2"
            (click)="owlCar.prev()">
            <svg class="custom-icon" xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 40 40"
              focusable="false" aria-hidden="true" data-di-res-id="ca1abdf8-d437167" data-di-rand="1725952672698">
              <g fill="none" fill-rule="evenodd">
                <g>
                  <circle cx="20" cy="20" r="20"></circle>
                  <g fill-rule="nonzero">
                    <path d="M15.179 3.173L16.043 4.077 7.765 12 16.043 19.923 15.179 20.827 5.957 12z"
                      transform="translate(8 8)" fill="#ffffff"></path>
                  </g>
                </g>
              </g>
            </svg>
          </button>
          <button class="owl-nav d-flex justify-content-center align-items-center owl-next"
            *ngIf="homePageData?.mainBannerResponse && homePageData.mainBannerResponse.length >= 2"
            (click)="owlCar.next()">
            <svg class="custom-icon" xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 40 40"
              focusable="false" aria-hidden="true" data-di-res-id="72a6da9d-f8bd046d" data-di-rand="1725952672699">
              <g>
                <circle cx="20" cy="20" r="20"></circle>
                <g fill-rule="nonzero">
                  <path d="M7.957 4.077L8.821 3.173 18.043 12 8.821 20.827 7.957 19.923 16.235 12z"
                    transform="translate(8 8)" fill="#ffffff"></path>
                </g>
              </g>
            </svg>
          </button>
        </div>
      </ng-template>
    </div>
    <div class="products">
      <div class="container w-100">
        <h3>Our Products</h3>
        <ng-container *ngIf="homePageData?.brandCategoryResponse?.length == 0; else loadingCategoryContent">
          <p class="placeholder-glow">
            <span class="placeholder col-12 w-100"
              [ngStyle]="(this.deviceStatus == 'lg' || this.deviceStatus == 'md') ? {'height':'26vh'}:{'height':'41vh'}"></span>
          </p>
        </ng-container>
        <ng-template #loadingCategoryContent>
          <div class="product-row">
            <div role="button" class="product-col" *ngFor="let catData of homePageData?.brandCategoryResponse">
              <a class="d-flex" role="button" [routerLink]="categoryCLickHandler(catData)"
                (click)="triggerCategoryClicked(utils.createNameForUrl(catData.categoryName))">
                <picture>
                  <img loading="lazy" width="75" height="75" [src]="catData?.featureImageFile"
                    [alt]="catData?.imageAltTag" class="w-100 h-100">
                </picture>
                <div class="description">
                  <h4>{{catData?.categoryName}}</h4>
                  <p *ngIf="utils.screenSizeObj.width >768">{{catData?.description | truncateStr:[85]}}
                  </p>
                  <p *ngIf="utils.screenSizeObj.width <=768">{{catData?.description | truncateStr:[50]}}
                  </p>
                  <label role="button" class="arrow">Learn More</label>
                </div>
              </a>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
    <div class="introdction">
      <ng-container
        *ngIf="(this.deviceStatus == 'lg' || this.deviceStatus == 'md') && smallWebBannerList?.length == 0; else loadingsmallWebBannerListContent">
        <p class="placeholder-glow">
          <span class="placeholder col-12 w-100 h-100"></span>
        </p>
      </ng-container>

      <ng-template #loadingsmallWebBannerListContent>
        <div #carousel *ngIf="utils.screenSizeObj.width >768 && smallWebBannerList" class="position-relative">
          <owl-carousel-o [options]="utils.customOptionsForSmallBanner">
            <ng-container *ngFor="let slideData of smallWebBannerList">
              <ng-template carouselSlide>
                <a [href]="slideData.link">
                  <img height="100" width="100" role="button" loading="lazy" [src]="slideData.image"
                    [alt]="slideData.altTag">
                </a>
              </ng-template>
            </ng-container>
          </owl-carousel-o>
        </div>
      </ng-template>

      <ng-container
        *ngIf=" (this.deviceStatus == 'xsm' || this.deviceStatus == 'sm') && smallMobileBannerList?.length == 0; else loadingsmallMobileBannerListContent">
        <p class="placeholder-glow">
          <span class="placeholder col-12 w-100 h-100"></span>
        </p>
      </ng-container>

      <ng-template #loadingsmallMobileBannerListContent>
        <div #carousel *ngIf="utils.screenSizeObj.width <=768 && smallMobileBannerList" class="position-relative">
          <owl-carousel-o [options]="utils.customOptionsForSmallBanner">
            <ng-container *ngFor="let slideData of smallMobileBannerList">
              <ng-template carouselSlide>
                <a [href]="slideData.link">
                  <img height="100" width="100" role="button" loading="lazy" [src]="slideData.image"
                    [alt]="slideData.altTag">
                </a>
              </ng-template>
            </ng-container>
          </owl-carousel-o>
        </div>
      </ng-template>
    </div>
    <div class="why-luminous">
      <div class="container">
        <div class="luminous-row">
          <div class="details">
            <h3>{{homePageData && homePageData?.brandLandingPageHeadingResponse?.heading}}</h3>
            <p class="pe-3">{{homePageData && homePageData?.brandLandingPageHeadingResponse?.description}}</p>
          </div>
          <!-- *ngIf="homePageData?.brandLandingPageContentManagementResponse" -->
          <div class="disturbation-network">
            <ul>
              <li
                *ngFor="let countData of homePageData?.brandLandingPageContentManagementResponse.counterNameTotalCounts;let i=index">
                <h3>{{countData.totalCounts}}</h3>
                <p>{{countData.counterName}}</p>
                <img height="20" width="20" loading="lazy" [src]="countSectionImg[i]" alt="Icons | Luminous">
              </li>
            </ul>
            <ng-container
              *ngIf="homePageData?.brandLandingPageContentManagementResponse?.length == 0; else loadingImagesContent">
              <p class="placeholder-glow">
                <span class="placeholder col-12 w-100 h-100"></span>
              </p>
            </ng-container>
            <ng-template #loadingImagesContent>
              <img height="50" width="50" class="customer-satisfaction-img" loading="lazy"
                [src]="homePageData?.brandLandingPageContentManagementResponse.counterNameImage.file"
                [alt]="homePageData?.brandLandingPageContentManagementResponse.counterNameImage.altTag">
            </ng-template>
          </div>
        </div>
      </div>
    </div>
    <div class="our-product bgWhite" *ngIf="productCarousalData && productCarousalData.length > 0">
      <div class="container">
        <h3>Our Products</h3>
        <app-carousal-page [genericCarousel]="true" [carouselSlideData]="productCarousalData" [isProductCarousel]="true"
          (imageClicked)="onProductClick($event)">
        </app-carousal-page>
      </div>
    </div>
    <div class="initiatives"
      *ngIf="homePageData && homePageData?.wordPressBlogList && homePageData?.wordPressBlogList.length > 0">
      <div class="container">
        <h3>Initiatives</h3>
        <app-carousal-page [genericCarousel]="true" [carouselSlideData]="homePageData?.wordPressBlogList">
        </app-carousal-page>
      </div>
    </div>
    <app-help-support></app-help-support>
  </div>
</div>